import React, { useMemo } from "react";

import {
  type MRT_ColumnDef,
} from "material-react-table";
import { Box, useTheme } from "@mui/material";
import IwSwitch from "../../../app/IwSwitch";
import { AdminGlobalTable } from "../../../tables/AdminGlobalTable";
import { cohortPolicyConfig } from "../../../../constants";

type viewSettings = {
  policy: string;
  key: string;
  enabled: boolean;
};

const ViewSettingsTable = ({policyState, setPolicyState}) => {
  const theme = useTheme();

  const data = useMemo<viewSettings[]>(
    () =>
      Object.entries(cohortPolicyConfig).map(([policy, key]) => ({
        policy,
        key,
        enabled: policyState[key] ?? false, 
      })),
    [policyState]
  );

  const handleToggle = (key: string) => {
    setPolicyState((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const columns = useMemo<MRT_ColumnDef<viewSettings>[]>(
    () => [
      {
        header: "POLICY",
        accessorKey: "policy",
        size:550
      },
      {
        header: "STATUS",
        muiTableHeadCellProps: {
          align: "right",
        },
        Cell: ({ row }) => (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <IwSwitch
              size="medium"
              checked={row.original.enabled}
              onChange={() => handleToggle(row.original.key)}
            />
          </Box>
        ),
      },
    ],
    [policyState]
  );

  return (
    <Box>
       <AdminGlobalTable
        columns={columns}
        data={data}
        config={{
          enableGlobalFilter: false,
          enableDensityToggle: false,
          enablePagination: false,
          muiSelectCheckboxProps: { color: "secondary" },
          muiTableContainerProps: {
            sx: {
              maxHeight: "calc(100vh - 450px)",
              minHeight: "calc(100vh - 450px)",
            },
          },
          muiTableBodyRowProps: () => ({
            hover: false,
            sx: {
              backgroundColor: "transparent",
              ":hover": { backgroundColor: theme.custom.hoverOptionColor },
            },
          }),
           renderTopToolbar: () => {
            return <></>;
          },
        
        }}
      />
    </Box>
  );
};

export default ViewSettingsTable;
